module.exports = __webpack_public_path__ + "img/view-bird-animation-2.e94a297c.png";